var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAll(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Offer Icon / all") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A41B32",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6E0C1D",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Offer-Icon-/-all",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7125159,1.31354402 L7.78318184,7.25299478 L1.22918732,8.20849907 C0.0538526455,8.37895742 -0.417174914,9.82791916 0.43516067,10.6578249 L5.17684687,15.2783809 L4.05535268,21.8054771 C3.85348372,22.985324 5.09606424,23.8690264 6.13681961,23.31726 L12,20.2353852 L17.8631804,23.31726 C18.9039358,23.864558 20.1465163,22.985324 19.9446473,21.8054771 L18.8231531,15.2783809 L23.5648393,10.6578249 C24.4171749,9.82791916 23.9461474,8.37895742 22.7708127,8.20849907 L16.2168182,7.25299478 L13.2874841,1.31354402 C12.762616,0.254871032 11.2418524,0.241421863 10.7125159,1.31354402 Z",
    id: "Path",
    fill: "url(#linearGradient-1)",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAll);
export default __webpack_public_path__ + "static/media/all.60927ec3cf3d72a5c8e98a7e8aba8830.svg";
export { ForwardRef as ReactComponent };